module.exports = __webpack_public_path__ + "assets/img/0216.33db4459.png";